import { BoosterType } from "../../../../../../common/models/data/BoosterType";
import { GameElement } from "../../../../models/field/GameElement";
import { WeaponType } from "../../../../models/data/WeaponType";
import { BASE_BOX_REWARDS_CONFIGURATION } from "./configuration/BaseConfiguration";

export class BoxReward {
    public readonly weapon?: { type: WeaponType, ammo: number };
    public readonly booster?: { type: BoosterType, count: number };
    public readonly coins?: number;
    public readonly heal?: number;
    
    constructor(public readonly type: GameElement) {
        switch (type) {
            case GameElement.BoosterBox: {
                const randomReward = this.getRandomReward(BASE_BOX_REWARDS_CONFIGURATION.BoosterBox);
                if (randomReward.type) {
                    this.booster = {
                        type: randomReward.type,
                        count: this.getRandomValueWithStep(randomReward.min, randomReward.max, 1)
                    }
                } else {
                    this.coins = this.getRandomValueWithStep(randomReward.min, randomReward.max);
                }
                break;
            }
            case GameElement.HealBox: {
                this.heal = this.getRandomValueWithStep(BASE_BOX_REWARDS_CONFIGURATION.HealBox[0].min, BASE_BOX_REWARDS_CONFIGURATION.HealBox[0].max);
                break;
            }
            case GameElement.WeaponsBox: {
                const randomReward = this.getRandomReward(BASE_BOX_REWARDS_CONFIGURATION.WeaponsBox);
                this.weapon = { type: randomReward.type, ammo: this.getRandomValueWithStep(randomReward.min, randomReward.max, 1) };
                break;
            }
            default: {
                throw new Error(`Can't create BoxReward for box type=${type}`);
            }
        }
    }

    private getRandomReward<T extends { chance: number }>(rewards: T[]): T | null {
        const totalChance = rewards.reduce((sum, item) => sum + item.chance, 0);

        // If all chances are 0, return null
        if (totalChance <= 0) return null;

        const rand = Math.random() * totalChance;
        let cumulative = 0;

        for (const reward of rewards) {
            cumulative += reward.chance;
            if (rand <= cumulative) {
                return reward;
            }
        }

        // Fallback (shouldn't happen if logic above is correct)
        return null;
    }

    private getRandomValueWithStep(min: number, max: number, step: number = 5): number {
        if (step <= 0) throw new Error("Step must be a positive number");
        if (min > max) throw new Error("Min cannot be greater than max");

        const range = Math.floor((max - min) / step);
        const randomStep = Math.floor(Math.random() * (range + 1));
        return min + randomStep * step;
    }
}